"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpHeaders = void 0;
var HttpHeaders;
(function (HttpHeaders) {
    HttpHeaders["CLIENT_SYSTEM_TIME"] = "x-client-system-time";
    HttpHeaders["CLIENT_VERSION"] = "x-client-version";
})(HttpHeaders || (exports.HttpHeaders = HttpHeaders = {}));
